
<template>
  <div class="buy-subscription-factor-form">
    <div class="d-lg-none d-xxs-flex my-md-1 my-sm-5 my-xxs-2 py-4" />
    <header
      class="d-flex flex-row justify-content-between align-items-center py-3 px-sm-5 px-xxs-3"
      :class="'bg-'+subscription.Accent"
    >
      <h2
        class="text-white"
      >
        {{ $t("UserProfile.Subscription.BuySubscriptionFactor.BuySubscription") }}
      </h2>
      <div :class="'bg-'+subscription.LightAccent" class="rounded-circle">
        <img :src="subscription.Icon" height="60" width="60" class="m-4">
      </div>
    </header>
    <article
      class="bg-light text-dark d-flex flex-column justify-content-around pt-sm-5 pt-xxs-4 pb-3 px-md-5 px-xxs-3"
    >
      <p
        class="lead pb-4"
        v-html="$t('UserProfile.Subscription.BuySubscriptionFactor.BuyDescription',{FullName:payment.User.FullName,SubscriptionTime:subscription.SubscriptionTime})"
      />
      <section class="d-flex justify-content-between align-items-center">
        <div>
          {{ subscription.Title }}
          <b-link @click="EditSubscriptionPlan(true)">
            <img src="@/assets/icons/pencil-edit-button.svg" height="15">
          </b-link>
        </div>
        <div>
          {{ payment.Price.Value }}
          {{ payment.Price.Unit }}
        </div>
      </section>

      <section
        v-if="payment.Price.Discount.InEditMode"
        class="d-flex justify-content-between align-items-center py-3"
      >
        <b-input-group>
          <b-input-group-prepend>
            <b-button variant="light" class="border" @click="ToggleDiscountCode()">
              <img class="bidi-icon" src="@/assets/icons/back.svg" height="22">
            </b-button>
          </b-input-group-prepend>
          <b-form-input v-model="payment.Price.Discount.Discount" type="text" />
          <b-input-group-append>
            <b-button variant="primary" @click="applyDiscountCodeStore()">
              {{ $t("UserProfile.Subscription.Apply") }}
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </section>
      <section v-else class="d-flex justify-content-between align-items-center py-3">
        <div>
          {{ $t("UserProfile.Subscription.BuySubscriptionFactor.HasDiscountCode") }}
          <b-link
            class="text-decoration-none"
            @click="ToggleDiscountCode"
          >
            {{ $t("UserProfile.Subscription.BuySubscriptionFactor.EnterDiscountCode") }}
          </b-link>
        </div>
        <div>
          {{ payment.Price.Discount.Price }}
          {{ payment.Price.Unit }}
        </div>
      </section>
      <section class="d-flex justify-content-between align-items-center">
        {{ $t("UserProfile.Subscription.BuySubscriptionFactor.VatPrice") }}
        <div>
          {{ payment.VAT.Price }}
          {{ payment.Price.Unit }}
        </div>
      </section>
      <section
        v-if="useCurrentBalance"
        class="d-flex justify-content-between align-items-center pt-3"
      >
        {{ $t("UserProfile.Subscription.BuySubscriptionFactor.withdrawAmount") }}
        <div>
          {{ accounting.WithdrawAmount }}
          {{ accounting.Unit }}
        </div>
      </section>
      <div class="border border-dark my-3" />
      <section class="d-flex justify-content-between text-secondary">
        {{ $t("UserProfile.Subscription.BuySubscriptionFactor.TotalPrice") }}
        <strong>
          {{ payment.Price.Total }}
          {{ payment.Price.Unit }}
        </strong>
      </section>
      <section
        class="d-flex flex-md-row-reverse flex-xxs-column justify-content-between align-items-center mt-4"
      >
        <b-form-checkbox
          v-model="useCurrentBalance"
          class="align-self-start align-items-center"
          @change="reCalculateFactor"
        >
          {{ $t("UserProfile.Subscription.BuySubscriptionFactor.UseBalance") }}
          <small
            class="text-success d-block my-0 mx-4"
          >
            {{ $t("UserProfile.Subscription.BuySubscriptionFactor.Balance", { Balance:accounting.CurrentBalance,Unit:accounting.Unit }) }}
          </small>
        </b-form-checkbox>

        <b-button
          class="flex-basis-auto col-md-6 col-xxs-12 align-self-md-end align-self-xxs-center my-md-0 my-xxs-3"
          variant="success"
          size="lg"
          @click="CheckoutToBank"
        >
          {{ $t("UserProfile.Subscription.Payment") }}
        </b-button>
      </section>
      <img

        class="mt-3 align-self-end"
        width="48"
        height="48"
        src="@/assets/icons/ZarinPal.png"
      >
    </article>
    <div class="angles position-relative">
      <div class="angle start position-absolute" />
      <div class="angle end position-absolute" />
    </div>
    <div class="barcode bg-light py-2 d-flex justify-content-center">
      <div class="barcode-image" />
    </div>
    <footer
      class="d-flex flex-md-row flex-xxs-column justify-content-between align-items-center px-xxs-2 px-sm-5 pt-2 pb-1"
    >
      <b-link
        :href="portalConfigurations.general.linkToTel"
        class="footer-link text-decoration-none"
      >
        {{ portalConfigurations.general.telText }}
      </b-link>
      <b-link target="_blank" class="footer-link text-decoration-none">
        {{ portalConfigurations.general.linkUrl }}
      </b-link>
      <span class="footer-link">
        {{ footer.Date }}
      </span>
    </footer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UserProfileNewUserSubscriptions from '@/components/UserProfileNewUserSubscriptions.vue'

export default {
  name: 'BuySubscriptionFactorForm',
  components: {
    UserProfileNewUserSubscriptions
  },
  props: {
    footer: {
      Date: String
    },
    payment: {
      User: {
        FullName: String
      },
      Price: {
        Value: Number,
        Discount: {
          Discount: String,
          Price: Number,
          InEditMode: Boolean
        },
        Total: Number,
        Unit: String
      },
      VAT: {
        Price: Number,
        Percent: Number
      }
    },
    accounting: {
      CurrentBalance: Number,
      Unit: String,
      WithdrawAmount: Number
    },
    subscription: {
      Title: String,
      SubscriptionTime: String,
      Accent: String,
      LightAccent: String,
      Icon: String,
      InEditMode: Boolean
    }
  },
  data () {
    return {
      useCurrentBalance: false,
      tempData: Object,
      withdrawAmount: Number
    }
  },
  computed: {
    ...mapGetters({
      portalConfigurations: 'tenantDesign/config',
      userWalletBalance: 'order/currentBalance'
    }),
    portalGeneralInfo () {
      return this.portalConfigurations.general
    }
  },
  methods: {
    ...mapActions({
      getUserBalance: 'order/setCurrentBalance'
    }),
    ToggleDiscountCode () {
      this.$emit('ToggleDiscountCode')
    },
    applyDiscountCodeStore () {
      this.$emit('applyDiscountCodeStore')
    },
    CheckoutToBank () {
      this.$emit('checkoutToBankStore', this.useCurrentBalance)
    },
    EditSubscriptionPlan (state) {
      this.$emit('SetSubscriptionMode', state)
    },
    reCalculateFactor (isChecked) {
      if (isChecked) {
        this.setTempData()
        this.updatePrices()
      } else {
        this.resetPrices()
      }
    },
    updatePrices () {
      this.isCurrentBalanceGreaterThanTotalPrice()
        ? this.updateUsersBalance()
        : this.withdrawUsersBalance()
    },
    isCurrentBalanceGreaterThanTotalPrice () {
      return this.accounting.CurrentBalance >= this.payment.Price.Total
    },
    updateUsersBalance () {
      this.accounting.CurrentBalance =
        this.accounting.CurrentBalance - this.payment.Price.Total
      this.accounting.WithdrawAmount = this.payment.Price.Total
      this.payment.Price.Total = 0
    },
    withdrawUsersBalance () {
      this.payment.Price.Total = this.payment.Price.Total - this.accounting.CurrentBalance
      this.accounting.WithdrawAmount =
        this.accounting.CurrentBalance
      this.accounting.CurrentBalance = 0
    },
    setTempData () {
      this.tempData = {
        TotalPrice: this.payment.Price.Total,
        CurrentBalance: this.accounting.CurrentBalance
      }
    },
    resetPrices () {
      this.payment.Price.Total = this.tempData.TotalPrice
      this.accounting.CurrentBalance = this.tempData.CurrentBalance
      this.accounting.WithdrawAmount = 0
    }
  },
  mounted () {
  },
  created () {
    this.getUserBalance().then(response => {
      this.accounting.CurrentBalance = (response.body.result.balance) / 10
    })
  }

}
</script>
